import { Component, ElementRef, ViewChild } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { UploadmodalComponent } from '../../uploadmodal/uploadmodal.component';
import { PageChangeEvent } from '@progress/kendo-angular-grid';
import { FileGridService } from './file-grid.service';
import { FinDeNavListFilesRequest } from '../../Models/Invoice';
import { FinDeNavListZipRequest } from '../../Models/Invoice';
import { SortDescriptor, process, State } from '@progress/kendo-data-query';
//import { GridService } from '../src/app/shared/services/grid.service';//
import { OverlayService, DynamicOverlayConfig } from '~/components/overlay.service';
import { OverlayConfig } from '@angular/cdk/overlay';

@Component({
  selector: 'app-file-grid',
  templateUrl: './file-grid.component.html',
  standalone: false,
  //providers: [GridService]
})
export class FileGridComponent {
  isVisible: boolean = false;
  public filteredDetails: any[] = [];
  public selectedRowFileName: string | null = null;
  public SelectedRowEnteredTs: string | null = null;
  public selectedRowId: string | null = null;
  selectedCustomer: string | null = null;
  public skip = 0;
  public gridView: any;
  public pageSize = 10;
  public sort: any[] = [];
  //objectKeys = Object.keys;
  showInvoicesDialog = false;
  showIncludedDialog = false;
  showMissingDialog = false;
  selectedItem: any;
  //public gridData: any[] = [];
  public gridData: FinDeNavListFilesRequest[] = [];
  public gridZipData: FinDeNavListZipRequest[] = [];


  errorMessage = '';
  constructor(private overlayService: OverlayService, private fileGridService: FileGridService) {}

  openModal() {
    const overlayConfig: DynamicOverlayConfig = {
      hasBackdrop: true,
      backdropClass: 'cdk-overlay-dark-backdrop',
      position: 'center',
      panelClass: 'custom-panel',
      scrollStrategy: 'reposition',
      disableClose: true,
    };
    this.overlayService.open(UploadmodalComponent, overlayConfig);
  }

  public state: State = {
    skip: this.skip,
    take: this.pageSize,
    sort: this.sort
  };




  ngOnInit(): void {

  this.LoadHeaderGrid();

  }

  LoadHeaderGrid()
  {
    this.fileGridService.getNavListFiles().subscribe((response) => {

      if (Array.isArray(response)) {
         // Sort by receivedTs descending (newest first)
        //  response.sort((a, b) => {
        //   const dateA = a.receivedTs ? new Date(a.receivedTs).getTime() : 0;
        //   const dateB = b.receivedTs ? new Date(b.receivedTs).getTime() : 0;
        //   return dateB - dateA; // descending: newest first
        // });

        this.gridData = response;
        this.loadPageItems();
      } else {
        console.error('Expected flat array but got:', response);
      }

      });
  }

  RefreshGrid() {
    // Clear grid state (paging & sorting)
  this.skip = 0;
  this.state = {
    skip: 0,
    take: this.gridData.length, // show all data
    sort: [] // clear sorting
  };

    this.isVisible = false;
    this.selectedRowId = "";
    this. LoadHeaderGrid();
  }

  public loadItems(): void {
    this.gridView = process(this.gridData, this.state);

  }

  public loadPageItems(): void {
   // this.gridView = process(this.gridData, this.state);
    this.gridView = {
      data: this.gridData.slice(this.skip, this.skip + this.pageSize),
      total: this.gridData.length,
    };
  }


  public pageChange(event: PageChangeEvent): void {
    this.skip = event.skip;
    this.state.skip = this.skip;
    this.loadPageItems();
    this.selectedRowId = "";
    //Clear the lower grid when the main grid page changes
    this.gridZipData = [];
  }

  sortChange(sort: SortDescriptor[]): void {
    this.sort = sort;
    this.state.sort = sort;
    this.loadItems();
  }


closeDialog(): void {
  this.showInvoicesDialog = false;
  this.showIncludedDialog = false;
  this.showMissingDialog = false;
  this.selectedItem = null;
  document.body.style.overflow = ''; // Restore scrolling
}


  onInvoicesLinkClick(dataItem: any) {

    this.selectedItem = dataItem;
    this.selectedCustomer = dataItem.customer;
    this.showInvoicesDialog = true;
    document.body.style.overflow = 'hidden'; // Lock background scrolling

  }

  onIncludedLinkClick(dataItem: any) {

    this.selectedItem = dataItem;
    this.selectedCustomer = dataItem.customer;
    this.showIncludedDialog = true;
    document.body.style.overflow = 'hidden'; // Lock background scrolling


  }

  onMissingLinkClick(dataItem: any) {
    console.log('Clicked item:', dataItem);
    this.selectedItem = dataItem;
    this.selectedCustomer = dataItem.customer;
    this.showMissingDialog = true;
    document.body.style.overflow = 'hidden'; // Lock background scrolling


  }
  public getSerialNumber(rowIndex: number): number {
    return this.skip + rowIndex + 1;
  }


  openDetailGrid(dataItem: any): void {
    this.isVisible = true;
   // console.log('openDetailGrid:', dataItem.fileName);
   // console.log(this.gridDataDetails);
    //console.log('Filtered:', this.gridDataDetails?.filter(d => d.fileName === dataItem.fileName));

   // console.log('dataItem.recievedTs',dataItem.receivedTs);
      // Filter the gridDataDetails based on the fileName from the selected row
     //** */ this.filteredDetails = this.gridDataDetails.filter(item => item.fileName === dataItem.fileName);

     // this.filteredDetails = dataItem.invoiceList || [];
     //*** */ this.filteredDetails = dataItem.clientInvoices || [];

    //** */  console.log('filteredDetails',this.filteredDetails);

    //**this.selectedRowFileName = dataItem.fileName;

    this.selectedRowId = dataItem.id;

    this.SelectedRowEnteredTs =  dataItem.receivedTs;
    const dataItemId = dataItem.id;

      this.fileGridService.getZipFilesList(dataItemId).subscribe((response) => {
       // this.fileGridService.getZipFilesList().subscribe((response) => {
        //   console.log('Raw API Response:', response);
        // console.log('Type of response:', typeof response);
        //   if (Array.isArray(response) && Array.isArray(response[0])) {
        //     this.gridData = response[0]; // Flatten the nested array
        //   } else {
        //     console.error('error response format:', response);
        //   }

        if (Array.isArray(response)) {
          this.gridZipData = response;


        } else {
          console.error('Expected flat array but got:', response);
        }

        });
  }

  onDownload(dataItem: any): void {

    var fileName =  dataItem.zipfileS3Path; //"GB.zip";  //
    var bucketName = dataItem.zipFileS3Bucket;
    this.fileGridService.getDownloadUrl(fileName, bucketName).subscribe(response => {
      const url = response.url;

      this.saveFromUrl(url, fileName.split('/').pop());
    });

  }

  onDownloadImport(dataItem: FinDeNavListFilesRequest): void {
    if (!dataItem.id || !dataItem.importS3Path) {
      return;
    }
    const fileName = dataItem.importS3Path.split('/').pop() || dataItem.fileName;
    this.fileGridService.getImportDownloadUrl(dataItem.id).subscribe({
      next: response => this.saveFromUrl(response.url, fileName),
      error: error => {
        console.error('Error getting the import file download url', error);
        alert('Download failed. Please try again.');
      }
    });
  }

  private saveFromUrl(url: string, fileName: string | undefined): void {
    this.fileGridService.downloadFile(url).subscribe({
      next: blob => {
        const a = document.createElement('a');
        const objectUrl = URL.createObjectURL(blob);
        a.href = objectUrl;
        a.download = fileName ?? '';
        a.click();
        URL.revokeObjectURL(objectUrl);
      },
      error: error => {
        console.error('Error downloading the file', error);
        alert('Download failed. Please try again.');
      }
    });
  }

  rowCallback = (context: { dataItem: any; index: number }) => {
    return {
      'highlight-red': context.dataItem.id === this.selectedRowId
    };
  };

}
